import React from "react";
import { useTranslation } from "react-i18next";

const DisabledPage: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="workflow-container">
      <div
        className="message"
        style={{
          textAlign: "center",
          padding: "40px 20px",
          fontSize: "18px",
          color: "#666",
        }}
      >
        {t("selfSignIn.disabled.invalidLink")}
      </div>
    </div>
  );
};

export default DisabledPage;
